import React, { FunctionComponent, useEffect, useState } from "react";
import { Button } from "@cmsgov/ds-medicare-gov";

import { initializePhraseAppEditor } from "react-intl-phraseapp";
import { RouteComponentProps, withRouter } from "react-router";
import URI from "urijs";

interface PhraseAppToolbarProps {
  onTranslationEnabled: () => void;
}

const PhraseAppToolbar: FunctionComponent<PhraseAppToolbarProps &
  RouteComponentProps> = props => {
  const [translating, setTranslating] = useState(false);
  const [bannerClosed, setBannerClosed] = useState(false);

  useEffect(() => {
    const uri = new URI(props.location.search);
    const { phrase_context } = uri.search(true);

    if (phrase_context && !translating) {
      toggleTranslationMode();
    }
  }, [props.location.search]);

  const toggleTranslationMode = (): void => {
    if (!translating) {
      setTranslating(true);

      const PHRASEAPP_PROJECT_ID = "4f74fd69f42f0309bdf1b2dde37c4dd3";

      const i18nConfig = {
        projectId: PHRASEAPP_PROJECT_ID,
        fullReparse: true,
        phraseEnabled: true,
      };

      initializePhraseAppEditor(i18nConfig);

      // Let the AppContext component know that all children should be destroyed and re-rendered
      props.onTranslationEnabled();
    } else {
      // Reload the page to remove the inserted PhraseApp script that controls the in-context editor
      window.location.reload(true);
    }
  };

  const toggleBanner = (): void => {
    setBannerClosed(!bannerClosed);
  };

  if (bannerClosed) {
    return (
      <Button
        size="small"
        className="ds-c-button--primary-alt"
        onClick={toggleBanner}
      >
        Open Translation Banner
      </Button>
    );
  }

  return (
    <div className="PhraseAppToolbar">
      <Button onClick={toggleTranslationMode}>
        {translating ? "Disable" : "Enable"} Translation Mode
      </Button>
      <Button
        size="small"
        className="ds-u-margin-left--2 e2e-close-phraseapp"
        onClick={toggleBanner}
      >
        X
      </Button>
    </div>
  );
};

export default withRouter(PhraseAppToolbar);
